$(document).ready(function() {

	//detects if under ie9 and displays a message.
	var ie = (function(){
	    var undef,
	        v = 3,
	        div = document.createElement('div'),
	        all = div.getElementsByTagName('i');

	    while (
	        div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->',
	        all[0]
	    );

	    return v > 4 ? v : undef;
	}());

	if (ie < 9 ){
		var message = "<div class='browser-message'>\
						   <h3>Browser outdated.</h3>\
						   <p>You are using an outdated browser. To get the best experience from this website install Chrome, Firefox or Internet Explore 9+. Thank you.</p>\
						   <p><small>*By accepting this message</small></p>\
						   <span class='btn js-message-close'>Close</span>\
					   </div>",
			messageOverlay = "<div class='message-overlay'></div>";
			
		$(message).appendTo('.message-overlay');
	}

	$('.js-message-close').on('click', function(){
		$('.message-overlay').hide();
	});


	$('a[rel^="external"]').click( function() {
		window.open( $(this).attr('href') );
		return false;
	});
	
	$(function($) {
		var num_cols = 2,
		container = $('.half-ul-container ul'),
		listItem = 'li',
		listClass = 'column half';
		container.each(function() {
			var items_per_col = new Array(),
			items = $(this).find(listItem),			
			min_items_per_col = Math.floor(items.length / num_cols),
			difference = items.length - (min_items_per_col * num_cols);
			for (var i = 0; i < num_cols; i++) {
				if (i < difference) {
					items_per_col[i] = min_items_per_col + 1;
				} else {
					items_per_col[i] = min_items_per_col;
				}
			}

			for (var i = 0; i < num_cols; i++) {
				$(this).append($('<ul></ul>').addClass(listClass));
				for (var j = 0; j < items_per_col[i]; j++) {
					var pointer = 0;
					for (var k = 0; k < i; k++) {
						pointer += items_per_col[k];
					}
					$(this).find('.half').last().append(items[j + pointer]);
				}
			}
			var savedItems = $(this).html();
			
			$(this).parent().html(savedItems);
		});
	});
	
	$('#submit').on('click', function() {
		//loading gif - generate this based on your colours at http://www.ajaxload.info/
		$("#loading").html('<div class="error_container">Loading...</div>');
		
		
		//the form fields
		var name = encodeURIComponent($('#name').val()),
			email = encodeURIComponent($('#email').val()),
			telephone = encodeURIComponent($('#telephone').val()),
			enquiry = encodeURIComponent($('#enquiry').val());
			

		$.ajax({
			url: $(location).attr('href'),
			data: "name=" + name + "&email=" + email + "&telephone=" + telephone + "&enquiry=" + enquiry + "&ajax=true",
			type: 'POST',
			success: function(data) {
				if (data != "Error") {
					//success message. 
					if(data.success == false) { 
						$("#loading").html(data.errormessage);
					} else {
						$("#form").html(data.success);
						
					}
				} else {
					alert("There was a problem, sorry!");
				}
			},
			dataType: "json"
		});
		
		return false;
		
	});

	$(window).resize(resize);

    $('body').on('click','.js-toggle-navigation, .js-open-nav',function(){
    	$('html').addClass('hide-arrow');
    	var state = !$('body').is('.show-navigation');
    	if(state){
    		reconstructImage();
    	} else {
    		shatterImage();
    	}
    	showNavigation(state);
    	return false;
    }).on('click','.js-close-navigation',function(){
    	shatterImage();
    	showNavigation(false);
    	return false;
    }).on('click',function(e){
    	if($(this).hasClass('show-navigation')){
    		var $target = $(e.target);
			if (!$target.is(".navigation-container") && $target.parents(".navigation-container").length == 0) {
				if(!compatibilityCheck.isMobile() && $(window).width() >= 960){
					shatterImage();
				}
			    showNavigation(false);
			    return false;
			}
    	}
    }).on('click','.js-ajax-nav, .js-ajax-load, footer .main-footer .tour-section .half-container ul li a',function(){
    	if(!compatibilityCheck.isIE([8,9])){
    		canShatter = false;
    		AjaxPageLoad.loadPage($(this).attr('href'));
	    	return false;
    	}
    }).on('click','.js-header-arrow',function(){
    	var top = $(this).parents('section').siblings('section').not('.news-inner').first().offset().top - $('header').outerHeight();
    	$('html, body').animate({scrollTop: top},1200,'easeInOutCubic');
    }).on('submit','#contact-form',function(){
    	FormSubmit.submit($(this));
    	return false;
    });
    bindScrollEvents();
    resize();
    headerShow();
    $('html').attr('data-useragent', navigator.userAgent);
    $(window).scroll();
});

var hoversTimeout = false;

function resize() {
	//functions to trigger on resize
}

function check_height_max(maxwidth) {
    var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
    return parseInt(width) <= parseInt(maxwidth);
}

function check_height_min(minwidth) {
    var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
    return parseInt(width) >= parseInt(minwidth);
}

function matchHeights() {
    var classes = ['same_height'];
    var height = 0;
    if (check_height_min(600)) {
        $.each(classes, function (_, className) {
            height = 0;
            $('.' + className).css("min-height", "");
            $('.' + className).each(function (i, obj) {
                if ($(this).outerHeight() > height) {
                    height = $(this).outerHeight();
                }
            });
            $('.' + className).css("min-height", height);
        });
    } else {
        $.each(classes, function (_, className) {
            $('.' + className).css("min-height", "");
        });
    }
}

function videosMatchHeights(){
	var classes = ['js-load-video'];
    var height = 0;
    if (check_height_min(600) && check_height_max(959)) {
        $.each(classes, function (_, className) {
            height = 0;
            $('.' + className).css("min-height", "");
            $('.' + className).each(function (i, obj) {
                if ($(this).outerHeight() > height) {
                    height = $(this).outerHeight();
                }
            });
            $('.' + className).css("min-height", height);
        });
    } else {
        $.each(classes, function (_, className) {
            $('.' + className).css("min-height", "");
        });
    }
}


function footerShow(){
	$('body').toggleClass('show-footer', $(window).scrollTop() + $(window).height() >= $('body').outerHeight() && canShatter);
}

function headerShow(){
	$('body').toggleClass('show-header', $(window).scrollTop() > 50 && !$('body').hasClass('no-scroll'));
}

function showNavigation(state){
	$('body').toggleClass('show-navigation',state);
	if(state === false){
		$('.navigation-items.hovers').removeClass('hovers');
		clearTimeout(hoversTimeout);
	} else {
		hoversTimeout = setTimeout(function(){
			$('.navigation-items').addClass('hovers');
		},3000);
	}
}

function bindScrollEvents(){
	$(window).scroll(function(){
        headerShow(); 
        videosMatchHeights();  
    });
    $(window).scroll(throttle(function () {
	   animate_objs();
	}, 100));
}

function animate_objs(){
	if(!canShatter){return false;}
	$('.js-animate').each(function () {
        viewportChecker($(this));
    });
}


function viewportChecker(obj){
	if(obj.is('.play')){return;}
	var offset = 0;
		if(typeof obj.attr('data-manual-trigger') !== 'undefined' || typeof obj.attr('data-function-trigger') !== 'undefined'){
			return;
		}
		if(typeof obj.attr('data-offset') !== 'undefined'){
			var offsetValue = parseInt(obj.attr('data-offset'));
				offset = $(window).height() / (100 / offsetValue);
		}
	var scrollPos = obj.offset().top + offset;
		if($(window).scrollTop() + $(window).height() >= scrollPos){
			obj.addClass('play');
			if(typeof obj.attr('data-function') !== 'undefined'){
				var fnName = obj.attr('data-function');
				$.each(fnName.split(','), function(index,value){
					if('function' === typeof window[value]){
						window[value].call(obj,obj);
					}
				});
			}
		}
}